import TYPE from '../actions/TYPE';

const initialState = {
  list: {},
  loading: false
};

const withdrawal = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.GET_LIST_BANK_SUCCESS:
      return {
        ...state,
        loading: true,
        list: action.payload
      };

    default:
      return state;
  }
};

export default withdrawal;
